/* eslint-disable react/prop-types */
import SubmitContext from 'context/submit/submitContext'
import PageContext from 'context/page/pageContext'
import PropTypes from 'prop-types'
import React, { useContext, useRef } from 'react'
import { Button, Card, CardBody, CardHeader } from 'reactstrap'
import ProductDesc from 'views/shared/ProductDesc'
import ImagesUpload from 'views/shared/ImagesUpload'
import SamplePackage from 'views/shared/SamplePackage'
import NotificationAlert from 'react-notification-alert'

const SinglePageVerticalProductInfo = ({
  productDesc = ({ brandSpecific }) => (
    <ProductDesc brandSpecific={brandSpecific} />
  ),
  imagesUpload = <ImagesUpload />,
  notice,
  nutritionInfo,
  packagingInfo = <SamplePackage />,
  productTitle,
  brandSpecific = false,
}) => {
  const submitContext = useContext(SubmitContext)
  const { updating, setResetting } = submitContext

  const pageContext = useContext(PageContext)
  const { setScrollToTop } = pageContext

  const hrStyle = {
    border: '1px dashed #98ca63',
    borderRadius: '1px',
  }

  console.log('brandSpecific: ' + brandSpecific)

  const notificationAlert = useRef()
  const notifyCancel = () => {
    let options = {
      place: 'bc',
      message: (
        <div>
          <div>Your changes have been canceled.</div>
        </div>
      ),
      type: 'info',
      icon: 'nc-icon nc-bell-55',
      autoDismiss: 7,
    }
    notificationAlert.current.notificationAlert(options)
  }

  return (
    <>
      <NotificationAlert ref={notificationAlert} />
      <Card>
        <CardHeader>
          <h5>{productTitle}</h5>
        </CardHeader>
        {notice && <div className="px-3">{notice}</div>}
        <CardBody>
          <h6 className="text-info">Description</h6>
          {productDesc({ brandSpecific: brandSpecific })}
          {nutritionInfo && (
            <>
              <hr style={hrStyle} />
              <h6 className="text-info">Nutrition</h6>
              {nutritionInfo}
            </>
          )}
          <hr style={hrStyle} />
          <h6 className="text-info">Packaging</h6>
          {packagingInfo}
          <hr style={hrStyle} />
          <h6 className="text-info">Images</h6>
          {imagesUpload}
          <Button
            className="btn-round float-right"
            type={'submit'}
            color="success"
            onClick={() => {
              setScrollToTop(true)
            }}
          >
            {updating ? 'Update Product' : 'Save'}
          </Button>
          {updating && (
            <Button
              className="btn-round float-right"
              color="danger"
              onClick={() => {
                setResetting(true)
                setScrollToTop(true)
                notifyCancel()
              }}
            >
              Cancel
            </Button>
          )}
        </CardBody>
      </Card>
    </>
  )
}

SinglePageVerticalProductInfo.propTypes = {
  productDesc: PropTypes.object,
  imagesUpload: PropTypes.object,
  packagingInfo: PropTypes.object,
}

export default SinglePageVerticalProductInfo
